<div class="flex gap-3 items-stretch w-full">
  <!-- ─── Main Card ────────────────────────────────────────────── -->
  <div class="flex-1 min-w-0 bg-white rounded-2xl border border-gray-200 shadow-sm flex flex-col h-[calc(100vh-180px)] overflow-visible">
    @if (loading) {
    <div class="py-24 text-center">
      <div class="w-10 h-10 rounded-full border-4 border-blue-100 border-t-blue-600 animate-spin mx-auto mb-4">
      </div>
      <p class="text-gray-500 text-sm">Chargement du reporting...</p>
    </div>
    } @else {

    <!-- Filters Bar -->
    <div class="px-6 py-4 border-b border-gray-100 bg-gray-50/50 rounded-t-2xl">
      <div class="flex flex-wrap items-end gap-4">
        <div class="min-w-[210px]">
          <div class="flex items-center justify-between gap-2 mb-1.5">
            <label class="block text-xs font-medium text-gray-500">Employé</label>
            @if(archivedEmployeeCount > 0) {
            <label class="flex items-center gap-1 text-[10px] font-medium text-gray-500 hover:text-gray-700 cursor-pointer whitespace-nowrap"
                   title="Les employés archivés sont masqués par défaut">
              <input type="checkbox" [(ngModel)]="showArchivedEmployees"
                     class="w-3 h-3 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer">
              Archivés ({{ archivedEmployeeCount }})
            </label>
            }
          </div>
          <div class="relative">
            <select [(ngModel)]="selectedEmployeeId" (change)="onFilterChange()" class="w-full appearance-none px-3 py-2 pr-8 rounded-lg text-sm bg-white border border-gray-200
                   focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400
                   hover:border-gray-300 outline-none cursor-pointer transition-all">
              <option value="">Tous les employés</option>
              @for (emp of visibleEmployees; track emp.id) {
              <option [value]="emp.cognitoId">{{ emp.firstName }} {{ emp.name }}{{ emp.isArchived ? ' (archivé)' : '' }}</option>
              }
            </select>
            <svg class="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none"
              fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>
        <div class="min-w-[160px]">
          <label class="block text-xs font-medium text-gray-500 mb-1.5">Statut</label>
          <div class="relative">
            <select [(ngModel)]="approvalStatusFilter" (change)="onFilterChange()" class="w-full appearance-none px-3 py-2 pr-8 rounded-lg text-sm bg-white border border-gray-200
                   focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400
                   hover:border-gray-300 outline-none cursor-pointer transition-all">
              <option value="">Tous</option>
              <option value="DRAFT">Non approuvé</option>
              <option value="APPROVED">Approuvé</option>
            </select>
            <svg class="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none"
              fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>
        <div class="project-filter-container min-w-[220px] relative">
          <label class="block text-xs font-medium text-gray-500 mb-1.5">Projet / Tâche</label>
          <button type="button" (click)="toggleProjectDropdown()" class="w-full flex items-center justify-between gap-2 px-3 py-2 rounded-lg text-sm bg-white border border-gray-200
                 hover:border-gray-300 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400
                 outline-none cursor-pointer transition-all text-left">
            <span class="flex items-center gap-2 min-w-0">
              <svg class="w-3.5 h-3.5 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor"
                viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
              </svg>
              @if (selectedProjects.size === 0) {
              <span class="text-gray-400 truncate">Tous les projets</span>
              } @else if (selectedProjects.size === 1) {
              <span class="text-gray-800 truncate">{{ resolveKeyName(selectedProjects.values().next().value ?? '')
                }}</span>
              } @else {
              <span class="text-gray-800 truncate">{{ selectedProjects.size }} projets</span>
              }
            </span>
            <div class="flex items-center gap-1.5 flex-shrink-0">
              @if (selectedProjects.size > 0) {
              <span
                class="inline-flex items-center justify-center w-4 h-4 text-[10px] font-bold rounded-full bg-blue-600 text-white">{{
                selectedProjects.size }}</span>
              <button type="button" (click)="$event.stopPropagation(); clearProjectFilter()"
                class="w-4 h-4 flex items-center justify-center rounded text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors cursor-pointer"
                title="Effacer">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
              }
              <svg class="w-4 h-4 text-gray-400 transition-transform duration-200"
                [class.rotate-180]="projectDropdownOpen" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </button>
          @if (projectDropdownOpen) {
          <div
            class="absolute top-full left-0 mt-1 w-full min-w-[240px] bg-white border border-gray-200 rounded-xl shadow-lg z-50 overflow-hidden">
            <div class="px-3 pt-3 pb-2 border-b border-gray-100">
              <input type="text" [(ngModel)]="projectSearch" placeholder="Rechercher..." class="w-full pl-3 pr-3 py-1.5 rounded-lg text-sm bg-gray-50 border border-gray-200
                       focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 outline-none transition-all" />
            </div>
            <div class="max-h-52 overflow-y-auto py-1">
              @if (filteredProjectOptions.length === 0) {
              <div class="px-4 py-3 text-sm text-gray-400 text-center">Aucun projet</div>
              }
              @for (proj of filteredProjectOptions; track proj) {
              <label
                class="flex items-center gap-3 px-3 py-2 hover:bg-blue-50/60 cursor-pointer transition-colors group">
                <div class="relative flex-shrink-0">
                  <input type="checkbox" [checked]="selectedProjects.has(proj)" (change)="toggleProject(proj)"
                    class="sr-only" />
                  <div class="w-4 h-4 rounded border-2 flex items-center justify-center transition-all"
                    [class]="selectedProjects.has(proj) ? 'bg-blue-600 border-blue-600' : 'border-gray-300 bg-white group-hover:border-blue-400'">
                    @if (selectedProjects.has(proj)) {
                    <svg class="w-2.5 h-2.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
                    </svg>
                    }
                  </div>
                </div>
                <span class="text-sm truncate"
                  [class]="selectedProjects.has(proj) ? 'text-blue-700 font-medium' : 'text-gray-700'">
                  {{ resolveKeyName(proj) }}
                </span>
              </label>
              }
            </div>
          </div>
          }
        </div>
        <div class="flex items-center gap-3 py-2">
          <div class="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5">
            <button (click)="setAggregationMode('project')"
              class="px-2.5 py-1 rounded-md text-[11px] font-medium transition-all cursor-pointer"
              [class]="aggregationMode === 'project' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">Par projet</button>
            <button (click)="setAggregationMode('phase')"
              class="px-2.5 py-1 rounded-md text-[11px] font-medium transition-all cursor-pointer"
              [class]="aggregationMode === 'phase' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">Par phase</button>
          </div>
          <span class="text-xs bg-gray-100 text-gray-600 px-2.5 py-1 rounded-lg font-medium">{{ allEntries.length }}
            prestations</span>
        </div>
      </div>
    </div>

    <!-- Period Selector -->
    <div class="px-6 py-3 border-b border-gray-100 flex items-center justify-between">
      <div class="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5">
        <button (click)="setPeriod('day')"
          class="px-3 py-1.5 rounded-md text-xs font-medium transition-all cursor-pointer"
          [class]="periodMode === 'day' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">Jour</button>
        <button (click)="setPeriod('week')"
          class="px-3 py-1.5 rounded-md text-xs font-medium transition-all cursor-pointer"
          [class]="periodMode === 'week' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">Semaine</button>
        <button (click)="setPeriod('month')"
          class="px-3 py-1.5 rounded-md text-xs font-medium transition-all cursor-pointer"
          [class]="periodMode === 'month' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">Mois</button>
        <button (click)="setPeriod('quarter')"
          class="px-3 py-1.5 rounded-md text-xs font-medium transition-all cursor-pointer"
          [class]="periodMode === 'quarter' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">Trimestre</button>
        @if (canShowAllPeriod) {
        <button (click)="setPeriod('all')"
          class="px-3 py-1.5 rounded-md text-xs font-medium transition-all cursor-pointer"
          [class]="periodMode === 'all' ? 'bg-indigo-600 text-white shadow-sm' : 'text-gray-500 hover:text-gray-700'">Tout</button>
        }
      </div>
      <div class="flex items-center gap-3">
        @if (periodMode !== 'all') {
        <button (click)="navigatePeriod(-1)"
          class="p-1.5 rounded-lg text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-all cursor-pointer">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button (click)="goToToday()"
          class="px-3 py-1 rounded-lg text-xs font-medium text-emerald-700 bg-emerald-50 border border-emerald-200 hover:bg-emerald-100 transition-all cursor-pointer">Aujourd'hui</button>
        }
        <span class="text-sm font-semibold text-gray-800 min-w-[140px] text-center">{{ periodLabel }}</span>
        @if (periodMode !== 'all') {
        <button (click)="navigatePeriod(1)"
          class="p-1.5 rounded-lg text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-all cursor-pointer">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>
        }
      </div>
      <div class="flex items-center justify-end w-[140px]">
        <button (click)="exportPdf(pdf)"
          class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold text-white bg-blue-600 hover:bg-blue-700 active:bg-blue-800 transition-all cursor-pointer shadow-sm"
          title="Télécharger le PDF directement">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          Exporter PDF
        </button>
      </div>
    </div>

    <!-- Main Content: Chart + Summary -->
    <div class="flex items-stretch flex-1 min-h-0 overflow-visible">
      <!-- Chart Area -->
      <div class="flex-1 px-6 py-4 border-r border-gray-100 flex flex-col min-w-0">
        <div class="flex items-stretch gap-0.5 flex-1 min-h-0">
          <div class="flex flex-col justify-between h-full pr-2 pb-[32px] flex-shrink-0">
            @for (label of yAxisLabels; track label) {
            <span class="text-[10px] text-gray-400 font-mono leading-none text-right w-6">{{ label }}h</span>
            }
          </div>
          <div class="flex-1 min-w-0 min-h-0" [class.overflow-x-auto]="chartMinWidth"
            [class.overflow-visible]="!chartMinWidth">
            <div class="flex items-stretch gap-[2px] h-full pb-0"
              [style.min-width.px]="chartMinWidth"
              [class.w-full]="!chartMinWidth">
            @for (bucket of dayBuckets; track bucket.dateKey) {
            <div class="flex-1 flex flex-col items-center h-full cursor-pointer group relative"
              [style.min-width.px]="chartMinWidth ? 40 : null"
              (click)="selectDay(bucket)" [class.opacity-40]="isWeekend(bucket) && bucket.totalHours === 0">
              <!-- Anchor the tooltip to the bar's left/right edge near the chart ends: a
                   260px-wide tooltip centred on a ~40px bar overflows the interface there. -->
              <div
                class="absolute bottom-full mb-2 px-3 py-2 bg-gray-900 text-white text-[10px] rounded-lg
                        opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-[100] shadow-xl
                        max-w-[260px] w-max"
                [ngClass]="$index <= 1 ? 'left-0' : ($index >= $count - 2 ? 'right-0' : 'left-1/2 -translate-x-1/2')">
                <div class="font-semibold mb-0.5">{{ bucket.label }}</div>
                <div class="mb-1">Total: {{ formatHours(bucket.totalHours) }}</div>
                @for (seg of bucket.projectSegments; track seg.name) {
                <div class="flex items-center gap-1.5">
                  <div class="w-2 h-2 rounded-full flex-shrink-0" [style.background-color]="seg.color"></div>
                  <span class="truncate">{{ seg.name.length > 35 ? seg.name.slice(0, 35) + '…' : seg.name }}</span>
                  <span class="flex-shrink-0 font-semibold">{{ formatHours(seg.hours) }}</span>
                </div>
                }
                <div class="text-gray-400 mt-1 border-t border-gray-700 pt-1">{{ bucket.entries.length }} entrée(s)</div>
              </div>
              <div class="w-full flex flex-col items-center justify-end flex-1 min-h-0">
                @for (segment of bucket.projectSegments; track segment.name) {
                <div class="w-full transition-all duration-200 shrink-0" [class.rounded-t-sm]="$first"
                  [style.height.%]="getSegmentPercent(segment, bucket)" [style.background-color]="segment.color">
                </div>
                }
              </div>
              <span class="text-[10px] text-gray-400 mt-1.5 font-medium leading-none truncate w-full text-center"
                [class.text-emerald-600]="isToday(bucket)" [class.font-bold]="isToday(bucket)"
                [class.text-blue-600]="selectedDay?.dateKey === bucket.dateKey">{{ bucket.label }}</span>
              @if (selectedDay?.dateKey === bucket.dateKey) {
              <div class="w-1.5 h-1.5 rounded-full bg-blue-600 mt-0.5"></div>
              }
            </div>
            }
            </div>
          </div>
        </div>
        <div class="flex items-center gap-4 mt-2 px-8 flex-wrap">
          @for (pb of projectBreakdowns; track pb.name) {
          <div class="flex items-center gap-1.5">
            <div class="w-3 h-3 rounded-sm" [style.background-color]="pb.color"></div>
            <span class="text-[10px] text-gray-500 truncate max-w-[100px]">{{ pb.name }}</span>
          </div>
          }
        </div>
      </div>
      <!-- Summary Sidebar -->
      <div class="w-[280px] flex-shrink-0 p-4 bg-gray-50/50 rounded-br-2xl flex flex-col min-h-0">
        <h3 class="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4 flex-shrink-0">Résumé</h3>
        <div class="grid grid-cols-2 gap-2 mb-4 flex-shrink-0">
          <div class="bg-white rounded-xl border border-gray-200 p-3 shadow-sm">
            <div class="text-[10px] text-gray-400 uppercase tracking-wider font-semibold mb-1">Ce jour</div>
            <div class="text-lg font-bold text-gray-900">{{ formatHours(todayHours) }}</div>
          </div>
          <div class="bg-white rounded-xl border border-gray-200 p-3 shadow-sm">
            <div class="text-[10px] text-gray-400 uppercase tracking-wider font-semibold mb-1">Semaine</div>
            <div class="text-lg font-bold text-gray-900">{{ formatHours(weekHours) }}</div>
            <div class="text-[10px] font-semibold mt-0.5"
              [class]="weekHours >= weekTarget ? 'text-emerald-600' : 'text-orange-500'">{{ formatPercent(weekHours,
              weekTarget) }}</div>
          </div>
          <div class="bg-white rounded-xl border border-gray-200 p-3 shadow-sm">
            <div class="text-[10px] text-gray-400 uppercase tracking-wider font-semibold mb-1">Ce mois</div>
            <div class="text-lg font-bold text-gray-900">{{ formatHours(monthHours) }}</div>
            <div class="text-[10px] font-semibold mt-0.5"
              [class]="monthHours >= monthTarget ? 'text-emerald-600' : 'text-orange-500'">{{ formatPercent(monthHours,
              monthTarget) }}</div>
          </div>
          <div class="bg-white rounded-xl border border-gray-200 p-3 shadow-sm">
            <div class="text-[10px] text-gray-400 uppercase tracking-wider font-semibold mb-1">Période</div>
            <div class="text-lg font-bold text-gray-900">{{ formatHours(totalHours) }}</div>
            <div class="text-[10px] text-gray-500 mt-0.5">{{ allEntries.length }} entrées</div>
          </div>
        </div>
        <div class="bg-white rounded-xl border border-gray-200 p-3 shadow-sm mb-4 flex-shrink-0">
          <div class="text-[10px] text-gray-400 uppercase tracking-wider font-semibold mb-2">Approbation</div>
          <div class="w-full h-2 bg-gray-100 rounded-full overflow-hidden mb-2">
            <div class="h-full bg-emerald-500 rounded-full transition-all duration-500"
              [style.width.%]="totalHours > 0 ? (approvedTotal / totalHours * 100) : 0"></div>
          </div>
          <div class="flex justify-between text-[11px]">
            <div class="flex items-center gap-1">
              <div class="w-2 h-2 rounded-full bg-emerald-500"></div><span class="text-gray-600">{{
                formatHours(approvedTotal) }}</span>
            </div>
            <div class="flex items-center gap-1">
              <div class="w-2 h-2 rounded-full bg-orange-400"></div><span class="text-gray-600">{{
                formatHours(draftTotal) }}</span>
            </div>
          </div>
        </div>
        <div class="bg-white rounded-xl border border-gray-200 p-3 shadow-sm flex flex-col min-h-0 flex-1">
          <div class="flex items-center justify-between mb-2 flex-shrink-0">
            <div class="text-[10px] text-gray-400 uppercase tracking-wider font-semibold">{{ aggregationMode === 'phase' ? 'Par phase' : 'Par projet' }}</div>
            @if (selectedDay) { <span class="text-[10px] text-blue-600 font-medium">{{ selectedDay.label }}</span> }
          </div>
          @if (projectBreakdowns.length === 0) { <p class="text-xs text-gray-400 italic">Aucune donnée</p> }
          <div class="space-y-2 overflow-y-auto min-h-0 flex-1">
            @for (pb of projectBreakdowns; track pb.name) {
            <div>
              <div class="flex items-center justify-between mb-0.5">
                <div class="flex items-center gap-1.5 min-w-0 flex-1">
                  <div class="w-2.5 h-2.5 rounded-sm flex-shrink-0" [style.background-color]="pb.color"></div>
                  @if (pb.type === 'task') {
                  <span
                    class="inline-flex items-center px-1 py-0.5 rounded text-[7px] font-semibold bg-purple-50 text-purple-700 border border-purple-100 flex-shrink-0">Task</span>
                  } @else {
                  <span
                    class="inline-flex items-center px-1 py-0.5 rounded text-[7px] font-semibold bg-blue-50 text-blue-700 border border-blue-100 flex-shrink-0">Proj</span>
                  }
                  <span class="text-[11px] font-medium text-gray-700 truncate">{{ pb.name }}</span>
                </div>
                <span class="text-[11px] font-semibold text-gray-900 flex-shrink-0 ml-2">{{ formatHours(pb.hours)
                  }}</span>
              </div>
              <div class="w-full h-1 bg-gray-100 rounded-full overflow-hidden">
                <div class="h-full rounded-full transition-all duration-300"
                  [style.width.%]="totalHours > 0 ? (pb.hours / totalHours * 100) : 0"
                  [style.background-color]="pb.color"></div>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>

    }
  </div>

  <!-- ─── Detail Panel (separate card, right side) ──────────────── -->
  @if (selectedDay) {
  <div @slidePanel
    class="w-[340px] flex-shrink-0 bg-white rounded-2xl border border-gray-200 shadow-sm flex flex-col self-stretch overflow-hidden h-[calc(100vh-180px)]">
    <div
      class="px-4 py-3 bg-blue-50/80 border-b border-blue-100 rounded-t-2xl flex items-center justify-between flex-shrink-0">
      <div class="flex items-center gap-2.5">
        <div class="w-7 h-7 rounded-lg bg-blue-100 flex items-center justify-center">
          <svg class="w-3.5 h-3.5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </div>
        <div>
          <h3 class="text-sm font-semibold text-gray-900">Prestations</h3>
          <p class="text-[11px] text-gray-500">{{ selectedDay.label }} · {{ selectedDay.entries.length }} entrée(s) · {{
            formatHours(selectedDay.totalHours) }}</p>
        </div>
      </div>
      <button (click)="clearDaySelection()"
        class="p-1.5 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-white/80 cursor-pointer transition-all">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    <div class="px-4 py-2 border-b border-gray-100 bg-gray-50/60 flex items-center gap-4 flex-shrink-0">
      <div class="flex items-center gap-1.5">
        <div class="w-2 h-2 rounded-full bg-emerald-500"></div><span class="text-[10px] text-gray-600">Approuvé <span
            class="font-semibold">{{ formatHours(selectedDay.approvedHours) }}</span></span>
      </div>
      <div class="flex items-center gap-1.5">
        <div class="w-2 h-2 rounded-full bg-orange-400"></div><span class="text-[10px] text-gray-600">Draft <span
            class="font-semibold">{{ formatHours(selectedDay.draftHours) }}</span></span>
      </div>
    </div>
    <div class="flex-1 overflow-y-auto">
      @for (entry of selectedDay.entries; track entry.id) {
      <div class="px-4 py-3 border-b border-gray-100 hover:bg-blue-50/30 transition-colors">
        <div class="flex items-center justify-between mb-1.5">
          <div class="flex items-center gap-2">
            <div
              class="w-6 h-6 rounded-md bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white text-[9px] font-bold flex-shrink-0">
              {{ getEmployeeName(entry.employeeId!).charAt(0) }}{{ getEmployeeName(entry.employeeId!).split("
              ")[1]?.charAt(0) || '' }}
            </div>
            <span class="font-medium text-gray-800 text-xs">{{ getEmployeeName(entry.employeeId!) }}</span>
          </div>
          <div class="flex items-center gap-1.5">
            @if ((entry.approvalStatus ?? 'DRAFT') === 'APPROVED') {
            <span
              class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[9px] font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200"><span
                class="w-1 h-1 rounded-full bg-emerald-500"></span>Approuvé</span>
            } @else {
            <span
              class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[9px] font-semibold bg-gray-100 text-gray-600 border border-gray-200"><span
                class="w-1 h-1 rounded-full bg-gray-400"></span>Draft</span>
            }
            @if ((entry.approvalStatus ?? 'DRAFT') !== 'APPROVED') {
            <button (click)="approveEntry(entry)"
              class="p-1 rounded text-emerald-500 hover:text-emerald-700 hover:bg-emerald-50 cursor-pointer transition-all"
              title="Approuver">
              <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
            </button>
            } @else {
            <button (click)="setDraftEntry(entry)"
              class="p-1 rounded text-gray-400 hover:text-orange-600 hover:bg-orange-50 cursor-pointer transition-all"
              title="Remettre en draft">
              <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
              </svg>
            </button>
            }
          </div>
        </div>
        <div class="flex items-center gap-1.5 mb-1">
          @if (getEntryType(entry.projectName) === 'CRM Task') {
          <span
            class="inline-flex items-center px-1 py-0.5 rounded text-[8px] font-medium bg-purple-50 text-purple-700 border border-purple-100">Task</span>
          } @else {
          <span
            class="inline-flex items-center px-1 py-0.5 rounded text-[8px] font-medium bg-blue-50 text-blue-700 border border-blue-100">Proj</span>
          }
          <span class="text-xs font-medium text-gray-800 truncate">{{ getEntryName(entry.projectName) }}</span>
        </div>
        <div class="flex items-center gap-3 text-[11px] text-gray-500">
          <span class="font-mono">{{ entry.startTime | date:'HH:mm' }} → {{ entry.endTime | date:'HH:mm' }}</span>
          <span class="font-semibold text-gray-700">{{ getDuration(entry.startTime, entry.endTime) }}</span>
          @if (entry.billable ?? true) { <span class="text-emerald-600">€</span> }
        </div>
        @if (entry.content) {
        <p class="text-[11px] text-gray-400 mt-1 line-clamp-1" [title]="entry.content">{{ entry.content }}</p>
        }
      </div>
      } @empty {
      <div class="px-4 py-12 text-center">
        <svg class="w-8 h-8 text-gray-300 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <p class="text-gray-400 text-xs">Aucune prestation</p>
      </div>
      }
    </div>
  </div>
  }
</div>

<!-- ─── Offscreen Direct Kendo PDF Export Container ──────────────── -->
<div class="absolute -left-[9999px] -top-[9999px]" aria-hidden="true">
  <kendo-pdf-export #pdf paperSize="A4" [landscape]="true" margin="15mm" [scale]="0.75" [repeatHeaders]="true">
    <!-- PdfSans is a TTF face; Kendo can only embed TrueType, and without it every
         accent falls back to StandardEncoding. See public/fonts/README.md. -->
    <!-- Width is tied to the page: A4 landscape at 15mm margins leaves 756.85pt,
         which is 1009px at scale 0.75. 1040px overflowed the right margin by 23pt. -->
    <div style="width: 1000px; background-color: #ffffff; color: #1e293b; font-family: 'PdfSans', 'Inter', system-ui, sans-serif; padding: 20px;">
      
      <!-- ================= PAGE 1: SYNTHÈSE / EXECUTIVE SUMMARY ================= -->
      <div class="page-break" style="page-break-after: always; break-after: page; margin-bottom: 24px;">
        <!-- Header -->
        <div style="display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 2px solid #f1f5f9; padding-bottom: 16px; margin-bottom: 20px;">
          <div>
            <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px;">
              <div style="width: 28px; height: 28px; border-radius: 6px; background-color: #2563eb; display: flex; align-items: center; justify-content: center; color: white; font-weight: bold; font-size: 14px;">S</div>
              <span style="font-size: 16px; font-weight: 700; letter-spacing: -0.025em; color: #0f172a;">SEL STUDIO</span>
            </div>
            <h1 style="font-size: 20px; font-weight: 700; color: #1e293b; margin: 0;">Rapport de Prestations</h1>
            <p style="font-size: 12px; color: #64748b; margin: 4px 0 0 0;">Période : <strong>{{ periodLabel }}</strong></p>
          </div>
          <div style="text-align: right; font-size: 11px;">
            <div style="font-size: 9px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.05em;">Généré le</div>
            <div style="font-weight: 700; color: #334155; margin-top: 2px;">{{ exportDate | date: 'dd/MM/yyyy à HH:mm' }}</div>
            <div style="margin-top: 8px; display: flex; flex-direction: column; align-items: flex-end; gap: 2px; font-size: 11px; color: #64748b;">
              <div>Employé : <strong>{{ selectedEmployeeId ? getEmployeeName(selectedEmployeeId) : 'Tous les employés' }}</strong></div>
              <div>Statut : <strong>{{ approvalStatusFilter === 'APPROVED' ? 'Approuvé' : approvalStatusFilter === 'DRAFT' ? 'Non approuvé' : 'Tous' }}</strong></div>
            </div>
          </div>
        </div>

        <!-- Page 1 Grid: Large KPIs -->
        <h2 style="font-size: 11px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.05em; margin-top: 0; margin-bottom: 12px;">Synthèse Globale de l'Activité</h2>
        <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; margin-bottom: 24px;">
          <!-- KPI 1 -->
          <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 20px; background-color: #f8fafc; border: 1px solid #f1f5f9; border-radius: 12px;">
            <div style="font-size: 9px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 4px;">Total des heures</div>
            <div style="font-size: 32px; font-weight: 700; color: #2563eb; font-family: monospace;">{{ formatHours(totalHours) }}</div>
            <div style="font-size: 10px; color: #94a3b8; margin-top: 4px; font-weight: 700;">{{ sortedEntriesForReport.length }} prestations enregistrées</div>
          </div>
          <!-- KPI 2 -->
          <div style="display: flex; flex-direction: column; justify-content: center; padding: 20px; background-color: #f8fafc; border: 1px solid #f1f5f9; border-radius: 12px;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;">
              <span style="font-size: 9px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.05em; display: flex; align-items: center; gap: 4px;"><span style="width: 6px; height: 6px; border-radius: 50%; background-color: #22c55e;"></span>Approuvées</span>
              <span style="font-size: 14px; font-weight: bold; color: #1e293b; font-family: monospace;">{{ formatHours(approvedTotal) }}</span>
            </div>
            <div style="width: 100%; height: 8px; background-color: #e2e8f0; border-radius: 9999px; overflow: hidden; margin-bottom: 4px;">
              <div [style.width.%]="totalHours > 0 ? (approvedTotal / totalHours * 100) : 0" style="height: 100%; background-color: #22c55e; border-radius: 9999px;"></div>
            </div>
            <div style="font-size: 10px; color: #64748b; font-weight: 500; text-align: right;">{{ totalHours > 0 ? (approvedTotal / totalHours | percent: '1.0-0') : '0%' }} du total</div>
          </div>
          <!-- KPI 3 -->
          <div style="display: flex; flex-direction: column; justify-content: center; padding: 20px; background-color: #f8fafc; border: 1px solid #f1f5f9; border-radius: 12px;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;">
              <span style="font-size: 9px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.05em; display: flex; align-items: center; gap: 4px;"><span style="width: 6px; height: 6px; border-radius: 50%; background-color: #fbbf24;"></span>Brouillons</span>
              <span style="font-size: 14px; font-weight: bold; color: #1e293b; font-family: monospace;">{{ formatHours(draftTotal) }}</span>
            </div>
            <div style="width: 100%; height: 8px; background-color: #e2e8f0; border-radius: 9999px; overflow: hidden; margin-bottom: 4px;">
              <div [style.width.%]="totalHours > 0 ? (draftTotal / totalHours * 100) : 0" style="height: 100%; background-color: #fbbf24; border-radius: 9999px;"></div>
            </div>
            <div style="font-size: 10px; color: #64748b; font-weight: 500; text-align: right;">{{ totalHours > 0 ? (draftTotal / totalHours | percent: '1.0-0') : '0%' }} du total</div>
          </div>
        </div>

        <!-- Page 1 Grid: Project vs Phase Breakdowns -->
        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 24px;">
          <!-- Left Column: Projects -->
          <div style="border: 1px solid #f1f5f9; border-radius: 12px; padding: 20px; background-color: white;">
            <h3 style="font-size: 12px; font-weight: 700; color: #475569; border-bottom: 2px solid #f8fafc; padding-bottom: 8px; margin-bottom: 12px;">Répartition par Projet</h3>
            @for (pb of getBreakdownsForType('project'); track pb.name) {
              <div style="margin-bottom: 10px;">
                <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 3px;">
                  <div style="display: flex; align-items: center; gap: 6px; min-width: 0; flex: 1;">
                    <div [style.background-color]="pb.color" style="width: 8px; height: 8px; border-radius: 2px; flex-shrink: 0;"></div>
                    <span style="font-size: 11px; font-weight: 700; color: #334155; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ pb.name }}</span>
                  </div>
                  <span style="font-size: 11px; font-weight: bold; color: #0f172a; font-family: monospace; margin-left: 8px;">{{ formatHours(pb.hours) }}</span>
                </div>
                <div style="display: flex; align-items: center; gap: 8px;">
                  <div style="flex: 1; height: 5px; background-color: #f1f5f9; border-radius: 9999px; overflow: hidden;">
                    <div [style.width.%]="totalHours > 0 ? (pb.hours / totalHours * 100) : 0" [style.background-color]="pb.color" style="height: 100%; border-radius: 9999px;"></div>
                  </div>
                  <span style="font-size: 10px; color: #94a3b8; font-weight: bold; width: 28px; text-align: right; font-family: monospace;">{{ totalHours > 0 ? (pb.hours / totalHours | percent: '1.0-0') : '0%' }}</span>
                </div>
              </div>
            } @empty {
              <p style="font-size: 11px; color: #94a3b8; font-style: italic; margin: 0; padding: 12px 0;">Aucun projet.</p>
            }
          </div>
          <!-- Right Column: Phases -->
          <div style="border: 1px solid #f1f5f9; border-radius: 12px; padding: 20px; background-color: white;">
            <h3 style="font-size: 12px; font-weight: 700; color: #475569; border-bottom: 2px solid #f8fafc; padding-bottom: 8px; margin-bottom: 12px;">Répartition par Phase / Tâche</h3>
            @for (pb of getBreakdownsForType('phase'); track pb.name) {
              <div style="margin-bottom: 10px;">
                <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 3px;">
                  <div style="display: flex; align-items: center; gap: 6px; min-width: 0; flex: 1;">
                    <div [style.background-color]="pb.color" style="width: 8px; height: 8px; border-radius: 2px; flex-shrink: 0;"></div>
                    <span style="font-size: 11px; font-weight: 700; color: #334155; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ pb.name }}</span>
                  </div>
                  <span style="font-size: 11px; font-weight: bold; color: #0f172a; font-family: monospace; margin-left: 8px;">{{ formatHours(pb.hours) }}</span>
                </div>
                <div style="display: flex; align-items: center; gap: 8px;">
                  <div style="flex: 1; height: 5px; background-color: #f1f5f9; border-radius: 9999px; overflow: hidden;">
                    <div [style.width.%]="totalHours > 0 ? (pb.hours / totalHours * 100) : 0" [style.background-color]="pb.color" style="height: 100%; border-radius: 9999px;"></div>
                  </div>
                  <span style="font-size: 10px; color: #94a3b8; font-weight: bold; width: 28px; text-align: right; font-family: monospace;">{{ totalHours > 0 ? (pb.hours / totalHours | percent: '1.0-0') : '0%' }}</span>
                </div>
              </div>
            } @empty {
              <p style="font-size: 11px; color: #94a3b8; font-style: italic; margin: 0; padding: 12px 0;">Aucune phase.</p>
            }
          </div>
        </div>

        <!-- Footer P1 -->
        <div style="margin-top: 32px; border-top: 1px solid #f1f5f9; padding-top: 12px; display: flex; justify-content: space-between; align-items: center; font-size: 9px; color: #94a3b8; font-weight: 500;">
          <div>Document de synthèse officielle - SEL Studio</div>
          <div>Page 1 sur {{ sortedEntriesForReport.length > 0 ? 2 : 1 }}</div>
        </div>
      </div>

      <!-- ================= PAGE 2+: JOURNAL DÉTAILLÉ (DETAILED LEDGER) ================= -->
      @if (sortedEntriesForReport.length > 0) {
        <div class="detailed-table-page">
          <!-- P2 Header -->
          <div style="display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 2px solid #f1f5f9; padding-bottom: 16px; margin-bottom: 20px;">
            <div>
              <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px;">
                <div style="width: 28px; height: 28px; border-radius: 6px; background-color: #475569; display: flex; align-items: center; justify-content: center; color: white; font-weight: bold; font-size: 14px;">S</div>
                <span style="font-size: 16px; font-weight: 700; letter-spacing: -0.025em; color: #475569;">SEL STUDIO</span>
              </div>
              <h1 style="font-size: 16px; font-weight: 700; color: #475569; margin: 0;">Journal Détaillé des Prestations</h1>
              <p style="font-size: 12px; color: #64748b; margin: 4px 0 0 0;">Période : <strong>{{ periodLabel }}</strong></p>
            </div>
            <div style="text-align: right; font-size: 11px;">
              <div>Employé : <strong>{{ selectedEmployeeId ? getEmployeeName(selectedEmployeeId) : 'Tous les employés' }}</strong></div>
              <div>Statut : <strong>{{ approvalStatusFilter === 'APPROVED' ? 'Approuvé' : approvalStatusFilter === 'DRAFT' ? 'Non approuvé' : 'Tous' }}</strong></div>
            </div>
          </div>

          <div style="border: 1px solid #f1f5f9; border-radius: 12px; overflow: hidden; background-color: white; margin-top: 16px;">
            <table style="width: 100%; border-collapse: collapse; font-size: 11px;">
              <thead>
                <tr style="background-color: #f8fafc; border-bottom: 1px solid #f1f5f9;">
                  <th style="padding: 12px 10px; width: 10%; text-align: left; font-size: 9px; font-weight: 700; color: #64748b; text-transform: uppercase;">Date</th>
                  @if (!selectedEmployeeId) {
                    <th style="padding: 12px 10px; width: 15%; text-align: left; font-size: 9px; font-weight: 700; color: #64748b; text-transform: uppercase;">Employé</th>
                  }
                  <th style="padding: 12px 10px; width: 22%; text-align: left; font-size: 9px; font-weight: 700; color: #64748b; text-transform: uppercase;">Projet</th>
                  <th style="padding: 12px 10px; width: 18%; text-align: left; font-size: 9px; font-weight: 700; color: #64748b; text-transform: uppercase;">Phase / Type</th>
                  <th style="padding: 12px 10px; width: 25%; text-align: left; font-size: 9px; font-weight: 700; color: #64748b; text-transform: uppercase;">Description</th>
                  <th style="padding: 12px 10px; width: 10%; text-align: right; font-size: 9px; font-weight: 700; color: #64748b; text-transform: uppercase;">Durée</th>
                  <th style="padding: 12px 10px; width: 10%; text-align: center; font-size: 9px; font-weight: 700; color: #64748b; text-transform: uppercase;">Statut</th>
                </tr>
              </thead>
              <tbody style="color: #475569;">
                @for (entry of sortedEntriesForReport; track entry.id) {
                  <tr style="page-break-inside: avoid; border-bottom: 1px solid #f1f5f9;">
                    <td style="padding: 12px 10px; font-family: monospace;">{{ entry.startTime | date: 'dd/MM/yyyy' }}</td>
                    @if (!selectedEmployeeId) {
                      <td style="padding: 12px 10px; font-weight: 700; color: #334155; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 110px;">{{ getEmployeeName(entry.employeeId!) }}</td>
                    }
                    <td style="padding: 12px 10px; font-weight: 700; color: #1e293b; max-width: 180px; word-break: break-word;">{{ getEntryName(entry.projectName) }}</td>
                    <td style="padding: 12px 10px; max-width: 150px; word-break: break-word;">
                      @if (getEntryType(entry.projectName) === 'CRM Task') {
                        <span style="display: inline-flex; align-items: center; padding: 2px 6px; border-radius: 4px; font-size: 10px; font-weight: 700; background-color: #faf5ff; color: #7e22ce; border: 1px solid #f3e8ff;">CRM Task</span>
                      } @else {
                        <span style="color: #64748b; font-weight: 500;">{{ getEntryPhaseName(entry) }}</span>
                      }
                    </td>
                    <td style="padding: 12px 10px; font-style: italic; max-width: 250px; word-break: break-word;">{{ entry.content || '—' }}</td>
                    <td style="padding: 12px 10px; text-align: right; font-weight: 700; color: #1e293b; font-family: monospace;">{{ getDuration(entry.startTime, entry.endTime) }}</td>
                    <td style="padding: 12px 10px; text-align: center;">
                      @if ((entry.approvalStatus ?? 'DRAFT') === 'APPROVED') {
                        <span style="display: inline-flex; align-items: center; gap: 4px; padding: 2px 8px; border-radius: 9999px; font-size: 10px; font-weight: 700; background-color: #f0fdf4; color: #15803d; border: 1px solid #bbf7d0;"><span style="width: 5px; height: 5px; border-radius: 50%; background-color: #22c55e;"></span>Approuvé</span>
                      } @else {
                        <span style="display: inline-flex; align-items: center; gap: 4px; padding: 2px 8px; border-radius: 9999px; font-size: 10px; font-weight: 700; background-color: #f8fafc; color: #64748b; border: 1px solid #e2e8f0;"><span style="width: 5px; height: 5px; border-radius: 50%; background-color: #cbd5e1;"></span>Brouillon</span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          <!-- Footer P2 -->
          <div style="margin-top: 24px; border-top: 1px solid #f1f5f9; padding-top: 12px; display: flex; justify-content: space-between; align-items: center; font-size: 9px; color: #94a3b8; font-weight: 500;">
            <div>Journal des activités détaillé - Généré depuis SEL Studio</div>
            <div>Page 2 sur 2</div>
          </div>
        </div>
      }

    </div>
  </kendo-pdf-export>
</div>